import {
	mySRCMClient,
	myStaticPageURL,
	myStaticProfileUpdateClient,
	volunteerServiceClient,
} from './HTTPClient';
import {
	MeProfile,
	MeProfilePage,
	StatesResponse,
	Language,
	GroupsResponse,
	ImportSaveFunctionaryCSVReportRequest,
	GetFunctionaryResponse,
	RegisterFunctionaryRequest,
	PositionAssignmentRequest,
	PositionAssignmentResponse,
	PositionAssignmentListResponse,
	PositionAssignmentFilters,
} from '../shared/MySrcm';
import { GetFunctionaryRequest } from '../shared/VolunteerApplicationServiceTypes';
import {
	COUNTRY_CODE_INDIA_FOR_REGIONS,
	ME_PROFILE_FIELDS,
	POSITION_ASSIGNMENTS_FIELDS,
} from '../shared/Constants';
import { mySRCMBaseURL, xClientId } from './EnvService';
import { AxiosResponse } from 'axios';

/* eslint-disable */
export const getMeProfile = async () => {
	const { getSRCMProfile } = await import('hfnauth/main');
	const response: AxiosResponse<MeProfile, any> = (await getSRCMProfile({
		srcmBaseURL: `${mySRCMBaseURL}/`,
		xClientId,
		queryParams: ME_PROFILE_FIELDS.join(','),
	})) as AxiosResponse<MeProfile, any>;
	return response.data;
};
/* eslint-enable */

export const getStates = async (): Promise<StatesResponse> => {
	const response = await mySRCMClient.get<StatesResponse>('states/');
	return response.data;
};

export const getCountryProfile = async (searchValue: string) => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`countries/?page_size=200&name__icontains=${searchValue}`
	);
	return response.data;
};
export const getStateProfile = async (
	CountryValue: string | number,
	searchValue: string
) => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`states/?country=${CountryValue}&page_size=200&name__icontains=${searchValue}`
	);
	return response.data;
};
export const getCityProfile = async (
	StateValue: number | string,
	searchValue: string | number
) => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`cities/?state=${StateValue}&page_size=200&name__icontains=${searchValue}`
	);
	return response.data;
};

export const getZonesProfile = async () => {
	const response = await myStaticProfileUpdateClient.get<MeProfilePage>(
		'/groups/zone/all.json'
	);
	return response.data;
};

export const getCenterProfile = async (parentID: number, searchKey: string) => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`/groups/?group_type=center&ancestor_group=${parentID}&page_size=200&name__icontains=${searchKey}`
	);
	return response.data;
};

export const getRegionsProfile = async () => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`/groups/?ancestor_group=${COUNTRY_CODE_INDIA_FOR_REGIONS}&group_type=region`
	);
	return response.data;
};

export const getZonesByRegion = async (regionId: number) => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`/groups/?ancestor_group=${regionId}&group_type=zone&page_size=2000`
	);
	return response.data;
};

export const getLanguages = async (): Promise<{ results: Language[] }> => {
	const response = await mySRCMClient.get<{ results: Language[] }>(
		`/languages/?page_size=100`
	);
	return response.data;
};

export const getZonesBySrcmGroupId = async (
	srcmGroupId: number
): Promise<GroupsResponse> => {
	const response = await mySRCMClient.get<GroupsResponse>(
		`/groups/${srcmGroupId}/`
	);
	return response.data;
};

export const createOrUpdatePositionAssignment = async (
	request: PositionAssignmentRequest
): Promise<PositionAssignmentResponse> => {
	const response =
		await volunteerServiceClient.post<PositionAssignmentResponse>(
			'createOrUpdatePositionAssignment',
			request
		);
	return response.data;
};

export const bulkUploadFunctionaries = async (
	request: ImportSaveFunctionaryCSVReportRequest
): Promise<boolean> => {
	const response = await volunteerServiceClient.post<boolean>(
		'bulkUploadFunctionaries',
		request
	);
	return response.data;
};

export const getFunctionary = async (
	request: GetFunctionaryRequest
): Promise<GetFunctionaryResponse> => {
	const response = await volunteerServiceClient.post<GetFunctionaryResponse>(
		'getFunctionary',
		request
	);
	return response.data;
};

export const getPositionAssignmentUsers = async (
	filters: PositionAssignmentFilters = {}
): Promise<PositionAssignmentListResponse> => {
	const params = {
		...filters,
		fields: POSITION_ASSIGNMENTS_FIELDS.join(','),
	};

	const response = await mySRCMClient.get<PositionAssignmentListResponse>(
		'position-assignment/application/users/',
		{
			params,
		}
	);

	return response.data;
};

export const registerFunctionary = async (
	request: RegisterFunctionaryRequest
): Promise<PositionAssignmentResponse> => {
	const response =
		await volunteerServiceClient.post<PositionAssignmentResponse>(
			'registerFunctionary',
			request
		);
	return response.data;
};

export const fetchGroupById = async (id: number): Promise<GroupsResponse> => {
	const response = await myStaticProfileUpdateClient.get<GroupsResponse>(
		`/groups/id/${id}.json`
	);
	return response.data;
};

export const getAbhyasiDetails = async (
	ref: string
): Promise<MeProfilePage> => {
	const response = await mySRCMClient.get<MeProfilePage>('abhyasis/', {
		params: {
			ref,
		},
	});

	return response.data;
};

export const getGroups = async () => {
	const response = await myStaticPageURL.get<GroupsResponse[]>(
		'/groups/data.json'
	);
	return response;
};

export const fetchStaticGroupById = async (
	id: number
): Promise<GroupsResponse> => {
	const response = await myStaticPageURL.get<GroupsResponse>(
		`/groups/id/${id}.json`
	);
	return response.data;
};

export const upsertPositionAssignment = async (
	request: PositionAssignmentRequest
): Promise<boolean> => {
	const response = await volunteerServiceClient.post<boolean>(
		'upsertPositionAssignment',
		request
	);
	return response.data;
};
